var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F2F4F7",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    d: "M13.004 13.277a.25.25 0 0 1 .114-.238.25.25 0 0 1 .133-.039h13.498a.25.25 0 0 1 .195.404l-6.584 8.234-.11.137V26.5h4.813a.25.25 0 1 1 0 .5H14.938a.25.25 0 1 1 0-.5h4.812v-4.725l-.11-.137-6.583-8.234a.25.25 0 0 1-.053-.127Zm1.806.223h-1.051l.663.816 1.83 2.25.15.184h7.228l.15-.188 1.8-2.25.65-.812H14.81Zm4.8 7.3.39.488.39-.488 2.19-2.738.65-.812h-6.46l.65.812 2.19 2.738Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.700596daf718902e971c7ec8d3d7fad3.svg";
export { ForwardRef as ReactComponent };